import { getDeviceInfo, PlatformType, } from '@office-start/device-detection-utility';
import { OfficeWorkload } from '@office-start/officehome-types';
// TODO: Either port activity tracking from angular or remove this function
export function getActivityStats() {
    return {};
    // TODO: Populate activity stats
    // const activityStats = this.activitySessionService.endSession();
    // if (activityStats) {
    //     // Record activity/inactivity duration in seconds to be consistent with how Aria records page session duration
    //     const inactivitySinceLastActivitySession = Performance.now() - activityStats.inactivityStartTime;
    //     sessionProperties.setProperty(InstrumentationParam.ActivityDuration, Math.ceil(activityStats.cumulativeDurationOfActivitySessions / 1000).toString());
    //     sessionProperties.setProperty(InstrumentationParam.InactivityDuration, Math.ceil((activityStats.cumulativeDurationBetweenActivitySessions + inactivitySinceLastActivitySession) / 1000).toString());
    //     sessionProperties.setProperty(InstrumentationParam.ItemCount, activityStats.activitySessionsCount.toString());
    //     sessionProperties.setProperty(InstrumentationParam.ClickCount, activityStats.cumulativeClickCount.toString());
    // }
}
// TODO: Get from settings resolver
export function getAriaSettings() {
    return Promise.resolve({
        ariaTenant: 'f2f1479f88ae422e99a52a31a63254f1-8630466a-9b3b-4883-9b2e-b0533b005adf-7273',
        ariaCollectorUrl: 'https://browser.pipe.aria.microsoft.com/Collector/3.0/',
    });
}
// TODO: why does this return a promise?
// TODO: Where should themeId come from? UserEntitlements?
export function getShellUserContext(userEntitlements) {
    return Promise.resolve({
        isAdmin: userEntitlements.IsAdmin,
        isSmb: userEntitlements.IsSmb,
        isIw: userEntitlements.IsIw,
        isEdu: userEntitlements.IsEdu,
        isEduStudent: userEntitlements.IsEduStudent,
        isEduFaculty: userEntitlements.IsEduFaculty,
        isDynamics: userEntitlements.IsDynamics,
        themeId: 'Base',
    });
}
// TODO: Get from ECS
export function getFeatureFlags() {
    return Promise.resolve({
        resourceLoggingEnabled: false,
    });
}
export function getAppPlatform(workload) {
    switch (workload) {
        case OfficeWorkload.Hwa:
            return 'Universal';
        default:
            return 'Web';
    }
}
export function getAppWorkload(workload) {
    switch (workload) {
        case OfficeWorkload.OfficeHome:
        case OfficeWorkload.OfficeHomeReact:
            return 'Web';
        case OfficeWorkload.Hwa:
            return 'HWA';
        case OfficeWorkload.Embed:
            return 'Embed';
        default:
            return 'Web';
    }
}
export function getDeviceType() {
    var deviceInfo = getDeviceInfo();
    switch (deviceInfo.platform.platformType) {
        case PlatformType.AndroidPhone:
            return 'AndroidPhone';
        case PlatformType.AndroidTablet:
            return 'AndroidTablet';
        case PlatformType.Chromebook:
            return 'Chromebook';
        case PlatformType.Linux:
            return 'Linux';
        case PlatformType.Mac:
            return 'Mac';
        case PlatformType.PC:
            return 'PC';
        case PlatformType.WindowsPhone:
            return 'WindowsPhone';
        case PlatformType.iPad:
            return 'iPad';
        case PlatformType.iPhone:
            return 'iPhone';
        default:
            return 'Other';
    }
}
